import { useEffect, useState } from 'react';
import { IBanner } from '~/types/banner';
import { fetchJson } from '../fetch';

export function useBanner() {
  const [bannerItem, setBannerItem] = useState<IBanner>();

  useEffect(() => {
    const fetchBanners = async (): Promise<void> => {
      // TODO: Add excluded banners (the ones already closed by the user)
      const { results } = await fetchJson('/api/banners/?format=json');

      setBannerItem(results[0]);
    };

    fetchBanners();
  }, []);

  return {
    bannerItem,
  };
}
